import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import { useEffect, useState } from 'react';
import type { HistoryCoursesFilterI, HistoryCourseI, PaginationMetaI } from 'types';

interface Props {
  init?: boolean;
}

const useHistoryCoursesApi = ({ init = false }: Props) => {
  const [data, setData] = useState<HistoryCourseI[]>([]);
  const [pagination, setPagination] = useState<PaginationMetaI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistoryCourses = async (filters: HistoryCoursesFilterI = {}) => {
    setLoading(true);
    setError(null);

    const response = await userCourseHistoryApi.getCoursesCollection(filters);

    setLoading(false);

    if (response.data) {
      setData(response.data ?? []);
      setPagination(response.pagination ?? null);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchHistoryCourses({ page: 1, limit: 15 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [init]);

  return { data, pagination, loading, error, fetchHistoryCourses };
};

export default useHistoryCoursesApi;
